import { ComponentInterface, FunctionalComponent, h } from '@stencil/core';
import { transformTagNames } from '../../../global/transform-tag-name';

interface AvatarProps {
  fullName: string;
  hasAvatar: boolean;
  hasImage: boolean;
  hasAvatarIcon: boolean;
  hasLabel: boolean;
  hasNotification: boolean;
  forceLabelNotification: boolean;
  handleImageSlotChange: (event: Event) => void;
  handleAvatarIconSlotChange: (event: Event) => void;
  bindAvatarEl: (el: HTMLElement) => void;
}

const Avatar = (that: ComponentInterface): FunctionalComponent<AvatarProps> => {
  return ({ fullName, hasAvatar, hasImage, hasAvatarIcon, hasLabel, hasNotification, forceLabelNotification, handleImageSlotChange, handleAvatarIconSlotChange, bindAvatarEl }) => {
    const { WbAvatar } = transformTagNames(that, 'wb-navigation-item', ['wb-avatar']);
    const isLabelNotificationForced = hasNotification && hasLabel && forceLabelNotification;
    const avatarHasNotification = hasNotification && hasAvatar && !isLabelNotificationForced;

    return (
      <span class="avatar">
        <WbAvatar size="xs" full-name={fullName} disable-focus ref={bindAvatarEl}>
          {hasImage && <slot name="image" slot="image" onSlotchange={handleImageSlotChange} />}
          {hasAvatarIcon && <slot name="icon" slot="icon" onSlotchange={handleAvatarIconSlotChange} />}
        </WbAvatar>
        {avatarHasNotification && <span class="notification" />}
      </span>
    );
  };
};

export { Avatar as bindAvatar };
